
import _ from "lodash"
import { encode, decode } from 'js-base64'

const searchProperty = (search, type, value) => {
	const tmp = {...search}
	if((value != null && Object.entries(value).length > 0) || typeof(value) == 'number'){
		tmp[type] = value
	}else{
		delete tmp[type]
	}
	return {
		search: tmp,
		isEqual: _.isEqual(tmp, search)
	}
}

const searchFromHash = () => {
    const encoded = getEncoded()
    if(encoded){
        try {
            const decoded = decode(encoded)
            const json = JSON.parse(decoded)
            return json
        } catch(err) {
            return {}
        }
    }else{
        return {}
    }
}

const objToEncoded = obj => {
    if(!obj) obj = {}
    const json = JSON.stringify(obj)
    const encoded = Object.entries(obj).length > 0 ? encode(json) : ''
    if(encoded){
        return 'query-' + encoded
    }else{
        return ''
    }
}

const getEncoded = () => document.location.hash.replace('#query-','')
const setEncoded = search => document.location.hash = objToEncoded(search)

const inPath = (path, bySearch) => {
    const pathname = document.location.pathname
    if(typeof path == 'string'){
        return pathname == path
    }
    if(typeof path == 'object' && path.length > 0){
        return path.includes(pathname)
    }
    return false
}

const inSearch = obj => {
    const search = searchFromHash()
    const keys = Object.getOwnPropertyNames(obj)
    return keys.map(key => obj[key] == search[key]).filter(item => item).length == keys.length
}

const store = (search_query, name, location_id, category_id, access_token, user_str_id) => {
    return new Promise((resolve, reject) => {
        axios.post('/api/search/store', {
            name: name,
            query: search_query ? search_query : null,
            location_id: location_id ? location_id : null,
            category_id: category_id ? category_id : null
        }, {
            headers: {
                Authorization: access_token ? ('Bearer ' + access_token) : null,
                Accept: 'application/json'
            },
            params: { user_str_id: user_str_id ? user_str_id : null }
        }).then(res => {
            resolve(res.data)
        }, res => {
            reject(res.response)
        })
    })
}

const list = (search, access_token) => {
    console.log('saved searches list')
    return new Promise((resolve, reject) => {
        axios.get('/api/search/list', {
            params: { s: search ? search : null },
            headers: { Authorization: 'Bearer ' + access_token }
        }).then(res => {
            resolve(res.data)
        }, res => {
            reject(res.response)
        })
    })
}

const deleteSearch = (id, access_token) => {
    return new Promise((resolve, reject) => {
        axios.delete('/api/search/' + id, {
            headers: {
                Authorization: access_token ? ('Bearer ' + access_token) : null,
                Accept: 'application/json'
            },
            params: {}
        }).then(res => {
            resolve(res.data)
        }, res => {
            reject(res.response)
        })
    })
}

const updateSearch = (id, data, access_token) => {
    return new Promise((resolve, reject) => {
        axios.post('/api/search/update/' + id, data, {
            headers: {
                Authorization: access_token ? ('Bearer ' + access_token) : null,
                Accept: 'application/json'
            }
        }).then(res => {
            resolve(res.data)
        }, res => {
            reject(res.response)
        })
    })
}

export {
    searchFromHash,
    searchProperty,
    getEncoded,
    setEncoded,
    objToEncoded,
    inSearch,
    inPath,
    store,
    list,
    deleteSearch,
    updateSearch
}